export default "__VITE_ASSET__6047433f__"